import { useState } from 'react';

/**
 * @param {import("../../data/types/import-type").ImportTypes} importType
 * @returns {import("../../data/types/types").CreateInitRequestHookReturn}
 */
export const useCreateInitRequest = (importType) => {
  const getClearedInitRequest = () => {
    return {
      csvFile: null,
      mapping: {
        mappingId: undefined,
        name: '',
      },
      importType,
    };
  };

  const [initRequest, setInitRequest] = useState(getClearedInitRequest());

  /**
   * @param {File | null} file
   * @returns {void}
   */
  const setFile = (file) => {
    setInitRequest((prev) => {
      return {
        ...prev,
        csvFile: file,
      };
    });
  };

  /**
   *
   * @param {import("../../data/types/types").ImportMapping} mapping
   * @returns {void}
   */
  const setMapping = (mapping) => {
    // no point of updating the entire state if mappingId is the same
    if (mapping.uniqueId === initRequest.mapping.uniqueId) {
      return;
    }

    setInitRequest((prev) => {
      return {
        ...prev,
        mapping,
      };
    });
  };

  /**
   * Clears the init request state
   * @returns {void}
   */
  const clearInitRequest = () => {
    setInitRequest(getClearedInitRequest());
  };

  return {
    initRequest,
    setFile,
    setMapping,
    clearInitRequest,
  };
};
